import React, { useState, useEffect } from 'react';
import { Layout, Menu, Button } from 'antd';
import { Link, Outlet, useLocation } from 'react-router-dom';
import {
  HomeOutlined,
  TeamOutlined,
  BarChartOutlined,
  LoginOutlined
} from '@ant-design/icons';

const { Header, Content, Footer } = Layout;

const PublicLayout = () => {
  const location = useLocation();
  const [user, setUser] = useState(null);


  useEffect(() => {

    const getUser = () => {
      const userData = JSON.parse(localStorage.getItem('user'));
      setUser(userData)
    }

    getUser()

  }, [])

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header style={{ backgroundColor: '#fff', padding: '0 20px' }}>
        <div className="logo" style={{ float: 'left', fontWeight: 'bold', fontSize: 20 }}>
          E-Sangha
        </div>
        <div style={{ float: 'right' }}>
          <Button type="link">
            <Link to="/login">
              <LoginOutlined /> {user?'เข้าใช้งานระบบ':'เข้าสู่ระบบ'}
            </Link>
          </Button>
        </div>
        <Menu
          theme="light"
          mode="horizontal"
          selectedKeys={[location.pathname]}
          style={{ float: 'center' }}
        >
          <Menu.Item key="/">
            <Link to="/">หน้าหลัก</Link>
          </Menu.Item>
          <Menu.Item key="/news">
            <Link to="/news">ข่าวสาร</Link>
          </Menu.Item>
        </Menu>
      </Header>

      <Content style={{ padding: '24px 48px', backgroundColor: '#f9f9f9' }}>
        <Outlet />
      </Content>

      <Footer style={{ textAlign: 'center' }}>
        © {new Date().getFullYear()} E-Sangha | พัฒนาระบบ โดย บริษัท อะตอมซอฟท์ จำกัด
      </Footer>
    </Layout>
  );
};

export default PublicLayout;
